import React, { Fragment, useState, useEffect } from 'react'
import { Button, FloatingLabel, Form, Toast } from "react-bootstrap"
import { useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { LoginUser } from '../Redux/UsersDucks'

const LoginPage = () => {
    const { register, formState: { errors }, handleSubmit } = useForm()
    const [message, setMessage] = useState("")
    const [messageBody, setMessageBody] = useState("")
    const [showToast, setShowToast] = useState(false)
    const [bgColor, setBgColor] = useState("info")

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const user = useSelector(store => store.users.user)

    const onLogin = (data) => {
        
        dispatch(LoginUser(data))
    }
    
    useEffect(() => {
        if(user.start){
            setShowToast(true)
            setBgColor("success")
            setMessage("Ingresando")
            setMessageBody(user.message)
        }
        else if(user.success){
            setShowToast(true)
            setBgColor("success")
            setMessage("Login exitoso")
            setMessageBody(`Bienvenido ${user.user.username}. Identificador ${user.user.identifier} Su sesión expira el ${new Date(user.user.expirationTime).toLocaleString()}.`)
            setTimeout(() => {
                navigate("/Home")
            }, 1000);
        } else if (user.message) {
            setShowToast(true)
            setBgColor("danger")
            setMessage("Error de login")
            setMessageBody(user.message)
        }
    }, [user, navigate])

    return (
        <Fragment>
            <section className="vh-100">
                <div className="container py-5 h-100">
                    <div className="row d-flex justify-content-center align-items-center h-100">
                        <div className="col col-xl-10">
                            <div className="card" style={{ borderRadius: "1rem" }}>
                                <div className="row g-0">
                                    <div className="col-md-6 col-lg-5 d-none d-md-block">
                                        <img src="./img/dc51d465-90e7-44b2-ac4b-a69928b9.webp" alt="login form" className="img-fluid" style={{ borderRadius: "1rem 0 0 1rem" }} />
                                    </div>
                                    <div className="col-md-6 col-lg-7 d-flex align-items-center">
                                        <div className="card-body p-4 p-lg-5 text-black">

                                            <Form onSubmit={handleSubmit(onLogin)}>
                                                <div className="d-flex align-items-center mb-3 pb-1">
                                                    <i className="fas fa-cubes fa-2x me-3" style={{ color: "#ff6219" }}></i>
                                                    <span className="w-100 mb-0 d-flex justify-content-center"> <img className='' src="./logo_bg.png" alt="..." width="80%" height="auto" /></span>
                                                </div>

                                                <h5 className="fw-normal mb-3 pb-3" style={{ letterSpacing: "1px" }}>Inicie sesión en su cuenta</h5>

                                                <FloatingLabel label="Correo@grupodefensa.cl" className="mb-4" >
                                                    <Form.Control type='text' placeholder="Usuario" {...register('email', { required: "Cuenta de usuario es obligatorio" })} />
                                                </FloatingLabel>
                                                <FloatingLabel label="Contraseña" className="mb-3" >
                                                    <Form.Control type='password' placeholder="Contraseña" {...register('password', { required: "Contraseña es obligatorio" })} />
                                                </FloatingLabel>
                                                <Button type='submit' className='btn btn-primary btn-lg'>Ingresar</Button> 
                                            </Form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Toast show={showToast} onClose={(e)=> setShowToast(false)} bg={bgColor}  className='position-fixed top-0 end-0 mt-3 me-3' style={{zIndex: "10000"}} delay={4000} autohide>
                <Toast.Header> <strong className="me-auto">{message}</strong> </Toast.Header>
                <Toast.Body> {messageBody} </Toast.Body>
            </Toast>

        </Fragment>
    );
}
export default LoginPage;